import Vue from 'vue'
import Vuex from 'vuex'
import dictOa from './dictoa'
import common from './common'

Vue.use(Vuex)

export default new Vuex.Store({
  getters: {
    appLoginNumber: state => state.common.appLoginNumber,
    screenWidth: state => state.common.screenWidth,
    logoBannerList: state => state.common.logoBannerList,
    dictOa: state => state.dictoa,
    scrollTop: state => state.common.scrollTop,
    isBackTop: state => state.common.isBackTop,
    appAngleMark: state => state.common.appAngleMark,
    appIdList: state => state.common.appIdList,
    appKeyList: state => state.common.appKeyList,
  },
  modules: {dictOa, common}
})
